/**=========================================================
 * Module: icons.js
 * Icons Controller
 =========================================================*/

 App.controller('IconsController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter) {
   
   
   $scope.page = {
       title: 'Icons',
       subTitle: '.aqi-'
   };

   $scope.icons = [];

   for(let i=0; i < document.styleSheets.length; i++){
    let sheet = document.styleSheets[i];
    if(sheet.href && sheet.href.endsWith('aqrate-icons.css')){
        for(let j=0; j < sheet.cssRules.length; j++){
            let rule = sheet.cssRules[j];
            if(rule && rule.selectorText){
                let selector = rule.selectorText.split(',')
                for(let k=0; k < selector.length; k++){
                    let selectorText = selector[k].trim();
                    if(selectorText && selectorText.startsWith('.aqi-') && selectorText.endsWith('::before')){
                        $scope.icons.push(selectorText.replace('.aqi-', '').replace('::before', ''));
                    }
                }
            }
        }
    }
   }

   $scope.icons.sort()

 }])